/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_Feedback_Create_SuccessInputs */

const es_tools_nexata_feedback_create_success = /** @type {(inputs: Tools_Nexata_Feedback_Create_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback registrado`)
};

const en_tools_nexata_feedback_create_success = /** @type {(inputs: Tools_Nexata_Feedback_Create_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback saved`)
};

/**
* | output |
* | --- |
* | "Feedback saved" |
*
* @param {Tools_Nexata_Feedback_Create_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_feedback_create_success = /** @type {((inputs?: Tools_Nexata_Feedback_Create_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_Feedback_Create_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_feedback_create_success(inputs)
	return en_tools_nexata_feedback_create_success(inputs)
});
export { tools_nexata_feedback_create_success as "tools.nexata.feedback_create_success" }